import React from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

export const BusquedaSolicitudes = ({ 
  searchTerm,
  onSearchChange,
  placeholder = "Buscar por descripción, ID o usuario...",
  style = {}
}) => {
  
  const handleChange = (e) => {
    onSearchChange(e.target.value);
  };

  return (
    <div className="busqueda-solicitudes" style={{ marginBottom: '16px', ...style }}>
      <Input
        placeholder={placeholder}
        prefix={<SearchOutlined style={{ color: 'var(--color-naranja)' }} />}
        value={searchTerm}
        onChange={handleChange}
        style={{ 
          width: '100%',
          maxWidth: '400px'
        }}
        allowClear
        size="middle"
      />
    </div>
  );
};